import { getGameURL } from "./getGameURL";
import QRCode from "qrcode";
import { QRCODE_OPTIONS } from "../constants";
import { DistributionPlace } from "../../model/DistributionPlace";

function base64QRCodeToPNG(base64Data: string, fileName = "qrcode.png") {
  if (!base64Data.startsWith("data:image")) {
    base64Data = "data:image/png;base64," + base64Data;
  }

  const link = document.createElement("a");

  link.href = base64Data;

  link.download = fileName;

  document.body.appendChild(link);

  link.click();

  document.body.removeChild(link);
}

export const generateBasicQRCode = async (
  configID?: string,
  fileName?: string
) => {
  const gameURL = getGameURL({ configID, place: DistributionPlace.QRCode });
  const base64 = await QRCode.toDataURL(gameURL, QRCODE_OPTIONS);
  base64QRCodeToPNG(base64, fileName);
};
